$(document).ready(function() {



	$.getJSON('https://api.flickr.com/services/rest/?&method=flickr.photosets.getList&api_key=2f0e634b471fdb47446abcb9c5afebdc&user_id=52732235@N03&primary_photo_extras=url_q&format=json&jsoncallback=?', function(data) {

		$.each(data.photosets.photoset, function(index, value) {
			var currentSet = data.photosets.photoset[index],
				currentSetId = currentSet.id,
				primaryURL = currentSet.primary_photo_extras.url_q,
				setTitle = currentSet.title._content,
				primaryImgTag = '<img src="'+primaryURL+'" alt="'+setTitle+'" >';

			$('#flickr-gallery').append('<a class="set-thumbnail" id="'+currentSetId+'" href="https://www.flickr.com/photos/52732235@N03/sets/'+currentSetId+'">'+primaryImgTag+'<span class="set-title">'+setTitle+'</span></a>')
		})

		if ($(window).width() > 860 ) {
			$(document).foundation();
		};

		$("#flickr-gallery").on("click", ".set-thumbnail", function(e) {
			e.preventDefault();
			var $this = $(this),
				currentSetId = $this.attr('id'),
				theIndex = $('.set-thumbnail').index($this),
				imgString = "";

			var traverse = 2 - ( theIndex % 2 ) - 1
			if ($(window).width() > 416) { traverse = 3 - ( theIndex % 3 ) - 1 };
			if ($(window).width() > 608) { traverse = 4 - ( theIndex % 4 ) - 1 };
			if ($(window).width() > 800) { traverse = 5 - ( theIndex % 5 ) - 1 };

			if ($this.hasClass('current-set')) {
				$('.photo').hide();
				$('#flickr-gallery h3').hide();
				$('#flickr-gallery .set-thumbnail').removeClass('current-set');
				$('#flickr-gallery img').css('opacity', '1');
			} else {
				$.getJSON("https://api.flickr.com/services/rest/?&method=flickr.photosets.getPhotos&api_key=2f0e634b471fdb47446abcb9c5afebdc&photoset_id="+currentSetId+"&extras=description,views,url_o,url_z,url_m,url_q&format=json&jsoncallback=?", function(response) {
					$('.photo').hide();
					$('#flickr-gallery h3').hide();
					var setTitle = response.photoset.title;
					$.each(response.photoset.photo, function(index, value) {
						var currentPhoto = response.photoset.photo[index],
							imgUrl = currentPhoto.url_q,
							photoTitle = currentPhoto.title,
							imgTag = '<li><a href="'+currentPhoto.url_o+'" class="photo"><img src="'+imgUrl+'" alt="'+photoTitle+'" ></a></li>';

						if (index == response.photoset.photo.length-1) {
							imgTag = '<li><a href="#" class="photo"><img src="'+imgUrl+'" alt="'+photoTitle+'" ></a></li>';
						};

						imgString += imgTag;

						
						$('#flickr-gallery .set-thumbnail img').css('opacity', '.3');
						$this.find('img').css('opacity', '1');
					})

					$($('.set-thumbnail').get(theIndex+traverse)).after('<h3>'+setTitle+'</h3><ul class="clearing-thumbs" data-clearing>'+imgString+'</ul>');

					if ($(window).width() > 860 ) {
						$(document).foundation();
					};

					$('#flickr-gallery .set-thumbnail').removeClass('current-set');
					$this.addClass('current-set');
				})
			}

			
		})

	})




})